const EMAIL_RE = /^[^\s@,;"'<>()[\]]+@[^\s@,;"'<>()[\]]+\.[^\s@,;"'<>()[\]]+$/;
const HEADER_WORDS = new Set(["email", "emails", "e-mail", "email address", "emailaddress", "mail"]);

/**
 * Parses free-form text (CSV contents, a pasted list, one-per-line, etc.) into emails.
 * Splits on commas, semicolons, tabs and newlines, so any column layout works.
 * Handles quoted cells and "Name <email@x.com>" entries.
 *
 * @param {string} text
 * @returns {{ emails: string[], invalid: string[] }} unique lowercase emails, and entries that
 *   looked like they were meant to be emails but were not valid (header cells are ignored).
 */
export function parseEmails(text) {
  const emails = [];
  const invalid = [];
  const seen = new Set();

  for (const raw of String(text ?? "").split(/[,;\t\r\n]+/)) {
    let token = raw.trim().replace(/^["']+|["']+$/g, "").trim();
    if (!token) continue;

    const angle = token.match(/<([^<>]+)>/);
    if (angle) token = angle[1].trim();

    const lower = token.toLowerCase();
    if (HEADER_WORDS.has(lower)) continue;

    if (EMAIL_RE.test(token)) {
      if (!seen.has(lower)) {
        seen.add(lower);
        emails.push(lower);
      }
    } else if (token.includes("@")) {
      // Only flag entries that look like attempted emails; other CSV columns (names, phones) are ignored.
      invalid.push(token);
    }
  }

  return { emails, invalid };
}
